/**
 * Confirmation Modal - Reusable modal for confirming actions
 */

export class ConfirmationModal {
  private modal: HTMLElement;
  private resolve: ((value: boolean) => void) | null = null;

  constructor() {
    this.modal = document.createElement("div");
    this.setupModal();
  }

  private setupModal() {
    this.modal.className = "hidden fixed inset-0 z-[60] flex items-center justify-center p-4 bg-slate-900/80 backdrop-blur-sm animate-in fade-in duration-200";
    this.modal.innerHTML = `
      <div class="relative w-full max-w-md bg-white dark:bg-surface-dark daylight:bg-day-raised rounded-2xl shadow-2xl daylight:shadow-day-modal border border-slate-200 dark:border-slate-800 daylight:border-day-ink/10 p-6 animate-in zoom-in-95 duration-200">
        <div class="mb-6">
          <h3 id="confirm-title" class="text-xl font-bold text-slate-900 dark:text-white daylight:text-day-ink mb-2">Confirm Action</h3>
          <p id="confirm-message" class="text-slate-600 dark:text-slate-400 daylight:text-day-ink-soft text-sm">Are you sure you want to proceed?</p>
        </div>
        <div class="flex gap-3 justify-end">
          <button id="confirm-cancel-btn" class="btn-secondary flex-1">Cancel</button>
          <button id="confirm-ok-btn" class="btn-primary flex-1">Confirm</button>
        </div>
      </div>
    `;
    document.body.appendChild(this.modal);

    this.modal.querySelector("#confirm-cancel-btn")?.addEventListener("click", () => this.close(false));
    this.modal.querySelector("#confirm-ok-btn")?.addEventListener("click", () => this.close(true));
    this.modal.addEventListener("click", (e) => {
        if (e.target === this.modal) this.close(false);
    });
  }

  open(title: string, message: string, confirmText: string = "Confirm", isDestructive: boolean = false): Promise<boolean> {
    return new Promise((resolve) => {
      this.resolve = resolve;
      const titleEl = this.modal.querySelector("#confirm-title");
      const msgEl = this.modal.querySelector("#confirm-message");
      const okBtn = this.modal.querySelector("#confirm-ok-btn");

      if (titleEl) titleEl.textContent = title;
      if (msgEl) msgEl.textContent = message;
      if (okBtn) {
        okBtn.textContent = confirmText;
        okBtn.className = isDestructive 
          ? "btn-primary flex-1 bg-red-600 hover:bg-red-700 text-white border-transparent shadow-red-500/20" 
          : "btn-primary flex-1";
      }

      this.modal.classList.remove("hidden");
    });
  }

  private close(result: boolean) {
    this.modal.classList.add("hidden");
    if (this.resolve) {
      this.resolve(result);
      this.resolve = null;
    }
  }
}